import { useState } from "react";
import {useSelector} from 'react-redux';
import ScratchGeneral from "./Scratch/ScratchGeneral";
import ScratchLook from "./Scratch/ScratchLook";
import '../../../../scss/pages/Scratch.scss';
import Lottie from "react-lottie-player";
import duplicate from '../../../../animations/duplicate.json';

function ScratchElementOptions({isPreview}) {
	const [tab, setTab] = useState('general');
	const {currentCampaign, currentCampaignId, currentPage, currentElement} = useSelector(state => state.user);
	const {locked} = currentCampaign;
	const [elementCopy, setElementCopy] = useState(JSON.parse(JSON.stringify(currentElement)));
	return (
		<div className="scratch__cms">
			{isPreview && 
				<div className="text--center">
					<Lottie
						loop
						animationData={duplicate}
						play
						style={{ width: 300, height: 300, margin: 'auto' }}
					/>
					<h3>This element is not editable. It's a fake spin.</h3>
					<div className="text--muted font--14">
						Changes on this elements are a reflection of the main wheel element.
					</div>
				</div>
			}
			{!isPreview &&
				<>
					<div className='tabs'>
						<div className={`tabs__item ${tab === 'general' && 'tabs__item-active'}`} onClick={() => setTab('general')}>
							General
						</div>
						<div className={`tabs__item ${tab === 'look' && 'tabs__item-active'}`} onClick={() => setTab('look')}>
							Look & Feel
						</div>
					</div>
					<div className="hr" />
					{tab === 'general' && <ScratchGeneral
						currentCampaignId={currentCampaignId}
						currentPage={currentPage}
						currentElement={currentElement}
						elementCopy={elementCopy}
						setElementCopy={setElementCopy}
						locked={locked}
					/>}
					{tab === 'look' && <ScratchLook
						currentCampaignId={currentCampaignId}
						currentPage={currentPage}
						currentElement={currentElement}
						elementCopy={elementCopy}
						setElementCopy={setElementCopy}
					/>}
				</>
			}
		</div>
	);
}

export default ScratchElementOptions;
